import React from 'react';
import { testimonials } from '../data/content';
export function Testimonials() {
  return <section className="w-full bg-white px-5 py-20 sm:py-28" data-id="element-168" data-mp="3kpugtgqsmnhi">
      <div className="mx-auto max-w-5xl" data-id="element-169" data-mp="3ksgwy4rr2bbc">
        <h2 className="text-center font-display text-[1.75rem] font-black leading-tight tracking-tight text-ink sm:text-[2.4rem]" data-id="element-170" data-mp="3fyvxs9ef7bak">
          <span aria-hidden="true" data-id="element-171" data-mp="3b01gxd00jwt3">⭐️ </span>Was Kollegen sagen
        </h2>
        <p className="mt-3 text-center text-sm font-medium text-ink/70" data-id="element-172" data-mp="36z94kavuhbsl">
          <span aria-hidden="true" data-id="element-173" data-mp="3205z4pbyd3k3">⭐️⭐️⭐️⭐️⭐️</span> 4.9/5 · +1.500 Lehrer
        </p>

        <div className="mx-auto mt-10 grid max-w-4xl gap-5 sm:grid-cols-3" data-id="element-174" data-mp="2x0temb8k08ko">
          {testimonials.map(item => <figure key={item.name} className="flex h-full flex-col rounded-2xl bg-sand p-6" data-id="element-175" data-mp="2s1yospc65jr2">
              <div className="text-sm text-amber-500" aria-label="5 von 5 Sternen" data-id="element-176" data-mp="v96ixwdpvphv">
                <span aria-hidden="true" data-id="element-177" data-mp="qac415ivel31">★ ★ ★ ★ ★</span>
              </div>
              <blockquote className="mt-4 flex-1 font-display text-sm italic leading-relaxed text-ink/85" data-id="element-178" data-mp="qb54xpv5egd9">
                &ldquo;{item.quote}&rdquo;
              </blockquote>
              <figcaption className="mt-6" data-id="element-179" data-mp="m5sx8bl09qli">
                <p className="text-xs font-bold text-ink" data-id="element-180" data-mp="77s75y6t68za">{item.name}</p>
                <p className="text-xs text-ink/50" data-id="element-181" data-mp="79le7elc2v7t">{item.location}</p>
              </figcaption>
            </figure>)}
        </div>

        <p className="mt-8 text-center text-[11px] text-ink/40" data-id="element-182" data-mp="zwpl5p3zljm8">
          Illustrative Kundenstimmen zu Demonstrationszwecken.
        </p>
      </div>
    </section>;
}